import gloAPI from "@/api/globals";

const state = () => ({
  searchedAddress: {},
  selectedAddress: {
    city: '',
    country: '',
    county: '',
    line_one: '',
    line_two: '',
    post_code: '',
  },
  recentlyViewed: [],
  searchItems: [],
  currentUser: {},
  currentUserLoading: false,
});

const mutations = {
  SET_SEARCHED_ADDRESSES(state,payload){
    state.searchedAddress = payload;
  },
  SET_CURRENT_USER(state,payload){
    state.currentUser = payload;
    state.currentUserLoading = false;
  },
  SET_CURRENT_USER_LOADING(state,payload){state.currentUserLoading = payload;},
  SET_ADDRESS(state,payload){
    if(payload.line_two===null){ payload.line_two = ''; }
    state.selectedAddress = payload;
  },
  SET_RECENTLY_VIEWED(state,payload){
    state.recentlyViewed = payload.reverse();
  },
  SET_SEARCH_ITEMS(state,payload){
    state.searchItems = payload;
  },
};

const actions = {
  async fetchCurrentUser({ commit }){
    commit('SET_CURRENT_USER_LOADING',true);
    let resp = await gloAPI.fetchCurrentUser();
    if(resp.status===200){
      commit("SET_CURRENT_USER",resp.data);
      localStorage.setItem('currentUser',JSON.stringify(resp.data));
    }
    commit('SET_CURRENT_USER_LOADING',false);
  },
  async getAddressByCode({ commit },postcode){
    let data = await gloAPI.getAddressByCode(postcode);
    if(data.status===200){
      commit("SET_SEARCHED_ADDRESSES",data.data);
    }
  },
  setSelectedAddress({ commit },payload){
    commit("SET_ADDRESS",payload);
  },
  getRecentlyViewed({ commit }){
    let recentlyViewed = JSON.parse(localStorage.getItem('recentlyViewed'));
    recentlyViewed = (recentlyViewed!==null)?recentlyViewed:[];
    commit("SET_RECENTLY_VIEWED",recentlyViewed);
  },
  addRecentlyViewed({ commit },viewed){
    let recentlyViewed = JSON.parse(localStorage.getItem('recentlyViewed'));
    recentlyViewed = (recentlyViewed!==null)?recentlyViewed:[];
    let length = recentlyViewed.length;
    if(length>0){
      recentlyViewed.forEach((rv,rvi) => {
        if(rv.id===viewed.id){ recentlyViewed.splice(rvi,1); }
      });
    }
    if(length>=11){ recentlyViewed.shift(); }
    recentlyViewed.push(viewed);
    localStorage.setItem('recentlyViewed',JSON.stringify(recentlyViewed));
    commit("SET_RECENTLY_VIEWED",recentlyViewed);
  },
  async getSearchItems({ commit },search){
    let data = await gloAPI.getSearchItems(search);
    let results = [];
    let responseData = data.data;
    Object.keys(responseData).forEach(type => {
      let typeObj = responseData[type];
      if(typeObj.results!==undefined){
        typeObj.results.forEach(res => {
          results.push({
            id: res.reference||res.lead_id||res.siteid||res.phonelineid,
            name: res.business,
            type: type,
            status: (type!=='accounts')?res.status:'',
            datetime: ''
          });
        });
      }
    });
    commit("SET_SEARCH_ITEMS",results);
  },
  clearSearchItems({ commit }){
    commit("SET_SEARCH_ITEMS",[]);
  },
};

const getters = {
  getCurrentUser: (state) => state.currentUser,
  getRecentlyViewedItems: (state) => {
    return state.recentlyViewed.filter((e,i)=>{
      return i<5;
    });
  },
  getCurrentUserRoles: (state) => {
    return (state.currentUser.roles!==undefined)?state.currentUser.roles.map((e)=>{return e.sid;}):[];
  },
  hasUserGotRole: (state) => role => {
    if(state.currentUser.roles===undefined){ return false; }
    let roles = state.currentUser.roles.map((e)=>{return e.sid;});
    return roles.indexOf(role)!==-1;
  },
  hasUserGotRoles: (state) => access => {
    if(state.currentUser.roles===undefined){ return false; }
    let roles = state.currentUser.roles.map((e)=>{return e.sid;});
    return roles.some(role => access.includes(role));
  },
  getUserRoles: (state) => {
    if(state.currentUser.roles===undefined){ return false; }
    return state.currentUser.roles.map((e)=>{return e.sid;});
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
